export default __webpack_public_path__ + "static/media/sample123.4e8d65da.pdf";